module.exports = __webpack_public_path__ + "static/media/community.9db78a1d.svg";